export default [
    {
        id: 1,
        name_ca: 'Ràpida',
        name_en: 'Quick',
        name_es: 'Rápida'
    },
    {
        id: 2,
        name_ca: 'Mitjana',
        name_en: 'Average',
        name_es: 'Media'
    },
    {
        id: 3,
        name_ca: 'Lenta, renovació alta',
        name_en: 'Slow, high renovation',
        name_es: 'Lenta, renovación alta'
    },
    {
        id: 4,
        name_ca: 'Lenta, renovació escassa',
        name_en: 'Slow, poor renovation',
        name_es: 'Lenta, renovación escasa'
    }
]


// WEBPACK FOOTER //
// ./src/options/evolution_speeds.js